import { Envs } from './types';

export const BASE_URL: {
    [env in Envs]: string
} = {
  local: 'https://api.dev.coretava.com',
  dev: 'https://api.dev.coretava.com',
  staging: 'https://api.staging.coretava.com',
  prod: 'https://api.coretava.com',
};
